<template>
  <div class="coupon-popup" v-if="dialogVisible">
    <div class="popup-box-wrapper">
      <div class="popup-close" @click="hidePopup">
        <img src="@/assets/image/icons/icon-close-circle.png">
      </div>
      <div class="popup-box">
        <div class="header">
          <div class="title">{{ $t('title') }}</div>
          <div class="subtitle">{{ $t('subTitle') }}</div>
        </div>
        <div class="coupon-list">
          <div v-for="(item,index) in unUsedCouponList" :key="index" class="coupon-item" @click="goCoupon">
            <div class="coupon-value">
              <div v-if="item.percentage" class="rate">{{ item.percentage }}%</div>
              <div v-else class="amount">
                <span class="unit">Rp</span>
                <span class="number">{{ item.rebate | formatMoney(true, true)}}</span>
              </div>
            </div>
            <div class="coupon-detail">
              <div class="name">{{ item.displayName[locale] }}</div>
              <div v-if="item.limitInvestMinAmount" class="desc">
                {{ $t('investLimit') }} {{ item.limitInvestMinAmount | formatMoney }}
              </div>
              <div v-else class="desc">{{ $t('noLimit') }}</div>
              <div class="btn-see">
                <md-button type="primary" plain round size="small" @click="goCoupon">{{ $t('see') }}</md-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Popup, Button } from 'mand-mobile'
import MdPopup from 'mand-mobile/components/popup/index'
import dialogMixins from '@/mixins/dialog'

export default {
  i18n: {
    messages: {
      en: {
        title: 'Congratulations',
        subTitle: 'you got coupons!',
        see: 'SEE',
        investLimit: 'Invest at least ',
        noLimit: 'No minimum investment amount',
      },
      id: {
        title: 'Selamat',
        subTitle: 'Anda mendapatkan kupon!',
        see: 'Lihat',
        investLimit: 'Minimum pendanaan ',
        noLimit: 'Tidak ada batas minimum pendanaan',
      },
    },
  },
  components: {
    MdPopup,
    [Popup.name]: Popup,
    [Button.name]: Button,
  },
  mixins: [dialogMixins],
  props: {
    unUsedCouponList: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      popupVisible: this.visible,
    }
  },
  computed: {
    locale() {
      return this.$store.state.locale
    },
  },
  methods: {
    hidePopup() {
      this.$emit('hideDialog')
      const timeStamp = this.moment().format('YYYYMMDD')
      localStorage.setItem('couponPopupDate', timeStamp)
    },
    goCoupon() {
      this.hidePopup()
      this.$router.push({ name: 'UserTicket' })
    },
  },
}
</script>

<style scoped lang="stylus">
.coupon-popup {
  z-index: 9999999;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, .8);
  .popup-box-wrapper {
    position: absolute;
    width: 90%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .popup-close {
    text-align: right;
    img {
      width: 25px;
      height: 25px;
      margin-bottom: 10px;
    }
  }
  .popup-box {
    padding: 30px 20px 20px;
    border-radius: 6px;
    background-color: color-primary;
    color: #fff;
    text-align: center;
    max-height: 70vh;
    overflow-y: scroll;
  }
  .header {
    line-height: 30px;
    .title {
      font-size: 24px;
      font-weight: bold;
    }
    .subtitle {
      font-size: 20px;
    }
  }
  .coupon-list {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .coupon-item {
    background-image: url('../../assets/image/user/ticket/bg-coupon-shadow.png');
    background-size: cover;
    padding: 16px 6px;
    width: 262px;
    height: 94px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    .coupon-value {
      width: 36%;
      color: color-primary;
      .rate {
        font-family: 'Reducto';
        font-size: 36px;
        line-height: 40px;
      }
      .amount {
        .unit {
          font-family: 'Reducto';
          font-size: 14px;
          margin-right: 2px;
        }
        .number {
          font-family: 'Reducto';
          font-size: 24px;
        }
      }
    }
    .coupon-detail {
      height: 100%;
      padding-left: 15px;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name {
        color: #3F424E;
        font-size: 14px;
      }
      .desc {
        color: #888;
        font-size: 10px;
      }
      .btn-see {
        .md-button.primary {
          font-size: 9px;
          line-height: 12px;
          width: 46px;
          &::after {
            border-radius: 80px;
          }
        }
      }
    }
  }

}
</style>
